import { ActivityListResponse } from "../../entities/AcitivityListResponse";
import { ActivityPlugin, ActivityPluginKey } from "./ActivityPluginTypes";

export class ActivityPluginRegistry {
  private static plugins = new Map<ActivityPluginKey, ActivityPlugin>();

  static register(plugin: ActivityPlugin): void {
    this.plugins.set(plugin.key, plugin);
  }

  static resolve(item: ActivityListResponse.Item): ActivityPlugin | null {
    for (const plugin of this.plugins.values()) {
      if (plugin.matches(item)) return plugin;
    }
    return null;
  }

  static getAll(): ActivityPlugin[] {
    return Array.from(this.plugins.values());
  }
}
